import { COUNTRIES_BY_CODE } from "@redotech/locale/countries";
import { USA_PROVINCES_BY_CODE } from "@redotech/locale/provinces";
import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface CustomerAddressState {
  country: string;
  provinceCodes: readonly string[];
}

export const CUSTOMER_ADDRESS = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CustomerAddressState>>,
): ConditionType<CustomerAddressState, Condition.CustomerAddress> => ({
  name: "Customer address",
  description(state) {
    if (!state.country) {
      return "No country selected";
    }
    const countryName = COUNTRIES_BY_CODE[state.country] || state.country;
    if (state.provinceCodes.length === 0) {
      return `${countryName}: No provinces selected`;
    }
    return `${countryName}: ${state.provinceCodes.length} province(s) selected`;
  },
  Details(props: ConditionTypeDetailsProps<CustomerAddressState>) {
    return React.createElement(Details, props);
  },
  empty: { country: "", provinceCodes: [] },
  fromModel(model) {
    return { country: model.country, provinceCodes: model.provinceCodes };
  },
  toModel(state) {
    return {
      type: Condition.CUSTOMER_ADDRESS,
      country: state.country,
      provinceCodes: state.provinceCodes,
    };
  },
  valid(state) {
    if (!state.country || !COUNTRIES_BY_CODE[state.country]) {
      return false;
    }
    if (state.provinceCodes.length === 0) {
      return false;
    }
    if (state.country === "US") {
      return state.provinceCodes.every(
        (provinceCode) => !!USA_PROVINCES_BY_CODE[provinceCode],
      );
    }
    return true;
  },
});
